class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.btnOpenMenu = document.querySelector('[data-mobile-menu-open]');
    this.btnCloseMenu = document.querySelector('[data-mobile-menu-close]');
    this.drawerOverlay = document.querySelector('[data-drawer-overlay]');
  }

  connectedCallback() {
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.btnOpenMenu?.addEventListener('click', this.openMenu);
    this.btnCloseMenu?.addEventListener('click', this.closeMenu);
    this.drawerOverlay?.addEventListener('click', this.closeMenu);

    this.addEventListener('click', this.handleClick);
  }

  openMenu() {
    document.body.style.setProperty('overflow', 'hidden', 'important');
    document.body.classList.add('m-mobile-menu-open');
    this.drawerOverlay?.classList.add('show-overlay');
    this.classList.add('m-mobile-menu__transform');
    this.btnOpenMenu.setAttribute('aria-expanded', 'true');
  }

  closeMenu() {
    document.body.style.setProperty('overflow', '');
    document.body.classList.remove('m-mobile-menu-open');
    this.drawerOverlay?.classList.remove('show-overlay');
    this.classList.remove('m-mobile-menu__transform');
    this.btnOpenMenu.setAttribute('aria-expanded', 'false');

    this.querySelectorAll('.m-mobile-menu__additional-menu').forEach((menu) => {
      menu.classList.remove('m-mobile-menu__transform');
      menu.setAttribute('aria-hidden', 'true');
    });

    this.querySelectorAll('.m-mobile-menu__nav-link[aria-expanded="true"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  handleClick(e) {
    const openBtn = e.target.closest('.m-mobile-menu__nav-link');
    const backBtn = e.target.closest('.m-mobile-menu__header-back');

    if (openBtn) {
      const parentLi = openBtn.closest('li');
      const subMenu = parentLi?.querySelector(':scope > .m-mobile-menu__additional-menu');

      if (subMenu) {
        e.preventDefault();
        subMenu.classList.add('m-mobile-menu__transform');
        subMenu.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
      }
    }

    if (backBtn) {
      const currentMenu = backBtn.closest('.m-mobile-menu__additional-menu');

      if (currentMenu) {
        currentMenu.classList.remove('m-mobile-menu__transform');
        currentMenu.setAttribute('aria-hidden', 'true');

        const openBtn = this.querySelector(`[aria-controls="${currentMenu.id}"]`);
        openBtn?.setAttribute('aria-expanded', 'false');
      }
    }
  }
}

customElements.define('mobile-menu', MobileMenu);
